import App from '../application.js'

import './setup_i18n'
import 'jquery-validation/dist/localization/messages_ar.js'
import '../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.ar.js'
import 'moment/locale/ar.js'
import './translations.tc.ar.js'

$.fn.datepicker.defaults.language = 'ar'

I18n.defaultLocale = 'ar'
I18n.locale = 'ar'

export default App
